import { apiClient } from './api';
import { BatchConfirmCashHandoverParams } from '../types/cash';

export const cashService = {
    confirmHandover: async (orderId: string, amountReceived?: number) => {
        const response = await apiClient.post('/confirmCashHandover', { orderId, amountReceived });
        return response.data;
    },

    batchConfirmHandover: async (params: BatchConfirmCashHandoverParams) => {
        const response = await apiClient.post('/batchConfirmCashHandover', params);
        return response.data;
    },

    // Note: We use ordersService.listOrders and filter by handoverStatus: 'PENDING'
};
